"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PronunciationApi = void 0;
const language_code_mapper_1 = require("../../mappers/language-code.mapper");
const generated_1 = require("./generated");
class PronunciationApi {
    constructor(configuration, basePath, axios) {
        this.pronunciationApi = new generated_1.PronunciationApi(configuration, basePath, axios);
        this.languageCodeMapper = new language_code_mapper_1.LanguageCodeMapper();
    }
    getPronunciationsV1(pronunciationRequest, options) {
        return this.pronunciationApi
            .getPronunciationsV1({
            ...pronunciationRequest,
            targetLanguage: this.languageCodeMapper.mapToGenerated(pronunciationRequest.targetLanguage),
        }, options)
            .then((r) => ({
            ...r,
            data: { ...r.data, language: this.languageCodeMapper.mapFromGenerated(r.data.language) },
        }));
    }
    getPronunciationsV2(pronunciationRequest, options) {
        return this.pronunciationApi
            .getPronunciationsV2({
            ...pronunciationRequest,
            targetLanguage: this.languageCodeMapper.mapToGenerated(pronunciationRequest.targetLanguage),
        }, options)
            .then((r) => ({
            ...r,
            data: { ...r.data, language: this.languageCodeMapper.mapFromGenerated(r.data.language) },
        }));
    }
}
exports.PronunciationApi = PronunciationApi;
//# sourceMappingURL=pronunciation-api.js.map